import {Component, Input} from '@angular/core';
import {AsiDialogView} from "@asi-ngtools/lib";
import {
  IDossierBloqueWebServiceClient,
  DossierBloqueDto,
  ResultFixedAnomaliesDto,
  FileProperties,
  DocumentInformation
} from "@resources/resources";
import {EtatEnums} from "@common/enum/Etat.enum";
import {PDFService} from "@common/services/pdf.service";

import {WaitingModalService, UserStore} from '@digicerba/common';
import {TranslateService} from "@ngx-translate/core";
import * as jsPDF from 'jspdf';
import {TypeAnomalies} from "@common/constants/TypeAnomalie";

@Component({
  selector: 'dialog-donnees-manquantes',
  templateUrl: './donnees-manquantes-component-dialog.component.html'
})

export class DonneesManquantesComponent extends AsiDialogView {

  readonly VISA_MAX_LENGTH = 2;
  dossierBloquesDTOs: Array<DossierBloqueDto>;
  numeroDossier: string;
  prenomNom: string;
  apiResult: ResultFixedAnomaliesDto;
  nom: string;
  prenom: string;
  dateDeNaissance: string;
  waiting: boolean;
  isChampsValides: boolean;
  hasNonDiscordantField: boolean;
  isVisaRequired: boolean;
  isVisaMissing: boolean;
  @Input() tab: string;
  @Input() fileProperties: FileProperties;

  @Input() status: EtatEnums;

  shouldRefreshDossiers: boolean;
  documentInformations: Array<DocumentInformation>;
  showSendButton: boolean;
  nbModifiedAValider: number;

  constructor(private dossierWebServiceClient: IDossierBloqueWebServiceClient,
              private pdfService: PDFService,
              private waitingModal: WaitingModalService,
              private translator: TranslateService,
              private userStore: UserStore) {

    super();
  }

  ngOnInit() {
    this.shouldRefreshDossiers = false;
    this.waiting = false;
    this.isChampsValides = false;
    this.hasNonDiscordantField = false;
    this.dossierBloquesDTOs = [];
    this.documentInformations = [];
    this.showSendButton = false;
    this.nbModifiedAValider = 0;
    this.isVisaRequired = false;
    this.isVisaMissing = true;
    this.dossierWebServiceClient.getDetailsByNumeroDossierAndEtat(this.numeroDossier, this.status.value()).subscribe(
      dossiersBloques => {
        if (dossiersBloques != undefined) {
          this.dossierBloquesDTOs.push(...dossiersBloques);
        }
      }
    );
  }

  masquerReturnMessageApresAffichage(data: DossierBloqueDto) {
    if (this.hasValidationResult()) {
      this.apiResult.validationResults.forEach(result => {
        if (result.anomalyFix.cleLigneAnalyseResultat == data.cleLigneAnalyseResultat && result.returnMessage != '') {
          result.returnMessage = '';
        }
      });
    }
  }

  setData(data: DossierBloqueDto) {
    this.masquerReturnMessageApresAffichage(data);
    this.dossierBloquesDTOs.forEach((dto) => {
      if (dto.cleLigneAnalyseResultat == data.cleLigneAnalyseResultat) {
        dto.resultatAnalyseSaisie = data.resultatAnalyseSaisie;
      }
    });
  }

  setVisaMissing(event: Event): void {
    const visaValue = (event.target as HTMLInputElement).value;

    if (visaValue !== '' && visaValue.length >= this.VISA_MAX_LENGTH) {
      this.isVisaMissing = false;
    } else {
      this.isVisaMissing = true;
    }
  }

  hasChampsValides(isValide: boolean) {
    this.dossierBloquesDTOs.forEach(e => {
      if (e.resultatAnalyseConfirm === true) {
        this.hasNonDiscordantField = true;
      }
    });
    this.isChampsValides = isValide ;
  }

  hasVisaRequired(isRequired: boolean) {
    this.isVisaRequired = isRequired;
  }

  hasDocuments() {
    return false;
  }


  isEtatTermine() {
    return this.status.value() == EtatEnums.TERMINE.value();
  }

  isEtatEnCours() {
    return this.status.value() == EtatEnums.EN_COURS.value();
  }

  isEtatAValider() {
    return this.status.value() == EtatEnums.A_VALIDER.value();
  }


  getResultatLabelTab(): string {
    if (this.isEtatEnCours()) {
      return this.translator.instant('MODAL.DONNEES_MANQUANTES.tab_donnees_a_saisir');
    }
    return this.translator.instant('MODAL.DONNEES_MANQUANTES.tab_donnees_saisie');
  }

  getDocumentsLabelTab(): string {
    if (this.isEtatEnCours()) {
      return this.translator.instant('MODAL.DONNEES_MANQUANTES.tab_documents_fournir');
    }
    return this.translator.instant('MODAL.DONNEES_MANQUANTES.tab_documents_fournis');
  }


  addFooter(pdf: jsPDF) {
    var pageHeight = pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight();
    var pageWidth = pdf.internal.pageSize.width || pdf.internal.pageSize.getWidth();
    // FOOTER

    const siegeSocial: string = this.translator.instant('MODAL.DONNEES_MANQUANTES.FOOTER.siege_social');
    const adresse = this.translator.instant('MODAL.DONNEES_MANQUANTES.FOOTER.adresse');
    const tel = this.translator.instant('MODAL.DONNEES_MANQUANTES.FOOTER.tel');
    const fax = this.translator.instant('MODAL.DONNEES_MANQUANTES.FOOTER.fax');
    const email = this.translator.instant('MODAL.DONNEES_MANQUANTES.FOOTER.email');


    pdf.setFontType('bold')
    pdf.setFontSize(10);
    pdf.setTextColor('gray');
    let firstLineFooter = siegeSocial + ' ' + adresse;
    let pdfMargin = (pageWidth - pdf.getTextWidth(firstLineFooter)) / 2;

    pdf.text(siegeSocial, pdfMargin, pageHeight - 30);
    pdf.setFontType('normal')
    pdf.text(adresse, pdfMargin + pdf.getTextWidth(siegeSocial) + 10, pageHeight - 30);

    let secondLineFooter = '\n' + tel + ' ' + fax + ' ' + email;
    pdfMargin = (pageWidth - pdf.getTextWidth(secondLineFooter)) / 2;
    pdf.text(secondLineFooter, pdfMargin, pageHeight - 30);

  }

  async imprimer() {

    const printElement = document.getElementById('print-section');
    const header = document.getElementById('header');
    const footer = document.getElementById('footer');

    header.style.display = 'block';
    footer.style.display = 'block';


    let orientation = 'portrait';
    let multipage = false;

    for (let i = 0; i < printElement.attributes.length; i++) {
      const attribute = printElement.attributes.item(i);
      if (attribute.name === 'orientation') {
        orientation = attribute.value;
      } else if (attribute.name === "multipage") {
        multipage = true;
      }

    }


    const margin = 20;
    const pdf = this.pdfService.createPDF(orientation, 'pt', 'a4');
    const pdfWidth = this.pdfService.getPDFWidth(pdf, margin);
    this.addFooter(pdf);

    this.waitingModal.openModal();

    await this.pdfService.printDiv(pdf, printElement as HTMLElement, margin, pdfWidth, multipage);
    header.style.display = 'none';
    footer.style.display = 'none';

    this.waitingModal.closeModal();
    window.open(pdf.output('bloburl'));
    this.pdfService.save(pdf, 'HTML-Document.pdf');
  }

  hasValidationResult() {
    if (this.apiResult == null || this.apiResult == undefined)
      return false;
    if (this.apiResult.validationResults == null || this.apiResult.validationResults == undefined)
      return false;
    return true;
  }


  hasValidationResultKO() {
    return this.hasValidationResult() && this.apiResult.validationResults.filter(value => value.statusCode == 'KO').length > 0;
  }

  hasValidationResultOK() {
    return this.hasValidationResult() && this.apiResult.validationResults.filter(value => value.statusCode == 'OK').length > 0;
  }

  closeWhenNoStatusKO() {
    if (!this.hasValidationResultKO())
      this.dialog.close(this.hasValidationResultOK());
  }

  praparerDossierBloquersDtos() {
    let userLogin = this.userStore.getLogin();
    this.dossierBloquesDTOs.forEach((d) => {
      if (d.resultatAnalyseSaisie == null || d.resultatAnalyseSaisie == "") {
        d.resultatAnalyseSaisie = "missed";
      }
      d.codeCorrespondantSaisie = userLogin;
    });
  }

  fixerAnomalies(nonMissedDossiersBloques: DossierBloqueDto[]) {
    this.waiting = true;
    const visaInput = document.getElementById('visa') as HTMLInputElement;
    const visaValue = visaInput.value;

    if (visaValue !== '') {
      this.dossierBloquesDTOs.forEach(e => {
       e.visa = visaValue;
      });
    }

    this.dossierWebServiceClient.fixerAnomalies(nonMissedDossiersBloques)
      .subscribe((apiResult) => {
        if (apiResult !== undefined)
          this.apiResult = apiResult;
        this.waiting = false;
        this.closeWhenNoStatusKO();

      }, (err) => {
        let error;
        if (err.status == 400) {
          error = this.translator.instant('MODAL.DONNEES_MANQUANTES.erreur_bad_request');
        } else {
          error = this.translator.instant('MODAL.DONNEES_MANQUANTES.erreur_fixed_anomalies');
        }
        this.waiting = false;

        window.alert(error);

      });
    this.refreshDossierBloque();
    if (this.getResultatsAnomalies().length == 0) {
      if (this.getDocumentsAnomalies().length == 0) {
        this.closeDialog();
      } else if (this.getDocumentsAnomalies().length == 0) {
        this.setTab('DOCUMENTS');
      }
    }
  }

  sendData() {
    this.praparerDossierBloquersDtos();
    let nonMissedDossiersBloques = this.dossierBloquesDTOs.filter(e => e.resultatAnalyseSaisie != 'missed');
    nonMissedDossiersBloques = nonMissedDossiersBloques.filter(e => e.resultatAnalyseConfirm == true);
    if (nonMissedDossiersBloques.length > 0) {
      this.fixerAnomalies(nonMissedDossiersBloques);
    }
  }

  closeDialog() {
    this.dialog.close(this.hasValidationResultOK());
  }

  getDocumentsAnomalies() {
    return this.dossierBloquesDTOs.filter(d => d.typeAnomalie == TypeAnomalies.DOCUMENTS);
  }

  getResultatsAnomalies() {
    let result = this.dossierBloquesDTOs.filter(d => d.typeAnomalie == TypeAnomalies.RESULTATS);
    return result;
  }

  setTab(tab: string) {
    this.tab = tab;
  }

  shouldRefresh() {
    this.shouldRefreshDossiers = true;
  }

  closeDialogDocuments() {
    this.dialog.close(this.shouldRefreshDossiers);
  }

  sendDocument() {
    if (this.nbDocumentsAnomaliesToFix() == 0) {
      if (this.getResultatsAnomalies().length > 0) {
        this.refreshDossierBloque();
        this.setTab('RESULTATS');
      } else if (this.getResultatsAnomalies().length == 0) {
        this.closeDialogDocuments();
      }
    } else if (this.nbDocumentsAnomaliesToFix() > 0) {
      this.showSendButton = false;
      this.refreshDossierBloque();
    }
    this.documentInformations = [];
  }

  refreshDossierBloque() {
    this.dossierBloquesDTOs = [];
    this.dossierWebServiceClient.getDetailsByNumeroDossierAndEtat(this.numeroDossier, this.status.value()).subscribe(
      dossiersBloques => {
        if (dossiersBloques != undefined) {
          this.dossierBloquesDTOs.push(...dossiersBloques);
        }
      }
    );
  }

  nbDocumentsAnomaliesToFix() {
    return this.getDocumentsAnomalies().length - this.getNbFixedDocuments();
  }

  deleteDocumentInfo(documentInformation: DocumentInformation) {
    for (let i = 0; i < this.documentInformations.length; i ++ ) {
      let documentInfo = this.documentInformations[i];
      if (documentInfo.numeroDossier === documentInformation.numeroDossier
        && documentInfo.cleLigneAnalyseResultat === documentInformation.cleLigneAnalyseResultat
        && documentInfo.codeCorrespondant === documentInformation.codeCorrespondant) {
        this.documentInformations.splice(i, 1);
        break;
      }
    }
  }

  addDocumentInfo(documentInformation: DocumentInformation) {
    let infoExist = false;
    for (let i = 0; i < this.documentInformations.length; i ++ ) {
      let documentInfo = this.documentInformations[i];
      if (documentInfo.numeroDossier === documentInformation.numeroDossier
        && documentInfo.cleLigneAnalyseResultat === documentInformation.cleLigneAnalyseResultat
        && documentInfo.codeCorrespondant === documentInformation.codeCorrespondant) {
        infoExist = true;
        break;
      }
    }
    if (infoExist == false) {
      this.documentInformations.push(documentInformation);
    }
  }

  addOrDeleteDocumentInfoInput(documentInformation: DocumentInformation) {
    if (documentInformation.action === 'ADD') {
      this.addDocumentInfo(documentInformation);
    } else if (documentInformation.action === 'DELETE') {
      this.deleteDocumentInfo(documentInformation);
    }

    if (this.getNbFixedDocuments() > 0) {
      this.showSendButton = true;
    } else {
      this.showSendButton = false;
    }
  }

  getNbFixedDocuments() {
    return this.documentInformations.length;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/utils/dialog/dialog-donnees-manquantes/donnees-manquantes-component-dialog.component.ts